import {Box, Button, Grid} from '@mui/material';
import React, {useContext, useEffect} from 'react';
import {makeStyles} from 'tss-react/mui';
import SelectDestinationField from './step1/search_bar/SelectDestinationField';
import SelectDateField from './step1/search_bar/SelectDateField';
import SetGuestsField from './step1/search_bar/SetGuestsField';
import SetCouponField from './step1/search_bar/SetCouponField';
import {MagnifyingGlass} from '@vectopus/atlas-icons-react';
import {useResponsive} from "@/hooks/use-responsive";
import {useTranslation} from "react-i18next";
import {AppContext} from "@/utils/appContext";
import {website} from "@/utils/helpers";
import { useParams } from 'react-router-dom';

export const SearchBar = (props: any) => {

  const appContext = useContext(AppContext);
  const {classes} = useStyles();
  const container = 'searchBar';
  const setQuantity = props.params.setQuantity;
  const setPets = props.params.setPets;
  const {search} = useParams();

  const upSm = useResponsive('up', 'sm');
  const {t} = useTranslation();

  return (
    <Grid
      container
      direction="row"
      justifyContent="left"
      alignItems="center"
      className={classes.form}
      id={'searchbar'}
    >
      {
        website.code === 'HU' && (
          <SelectDestinationField params={{container}}/>
        )
      }
      <SelectDateField params={{container}}/>
      <SetGuestsField params={{container, setQuantity, setPets}}/>
      <SetCouponField params={{container}}/>
      <Grid size={{ xs: 2 }} className={classes.submitContainer}>
        {
          upSm && (
            <Grid>
              {
                !appContext.updateSearch ? (
                  <Button
                    color={'secondary'}
                    id={'search'}
                    variant={'contained'}
                    type={'submit'}
                    fullWidth
                  >
                    {t('Cerca')}
                  </Button>
                ) : (
                  <Button
                    color={'secondary'}
                    id={'search'}
                    variant={'contained'}
                    type={'submit'}
                    fullWidth
                  >
                    {t('Update')}
                  </Button>
                )
              }
            </Grid>
          )
        }
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles()((theme) => {
  return {
    form: {
      maxWidth: 900,
      margin: 'auto',
      backgroundColor: 'transparent',
      '.MuiOutlinedInput-notchedOutline': {
        borderRadius: theme.radius.formBorderRadius + '!important'
      },
      '& .MuiGrid-root': {
        overflow: 'initial',
        marginLeft: website.code === 'VP' ? 10 : 2,
      },
      '& .MuiFormControl-root': {
        '& .MuiInputBase-root': {
          backgroundColor: website.code === 'VP' ? 'transparent' : '#F5F5F5',
          border: 'none',
          paddingLeft: 5
        },
        '& .MuiInputBase-inputAdornedStart': {
          paddingLeft: 15
        }
      }
    },
    submitContainer: {
      marginLeft: '0!important',
      height: 58,
      backgroundColor: website.code === 'VP' ? 'transparent' : '#F5F5F5',
      paddingRight: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      '.MuiGrid-root': {
        width: '100%!important'
      },
      '.MuiGrid-item': {
        overflow: 'visible'
      },
      '& button': {
        minWidth: '30px',
        height:  website.code === 'VP' ? '60px' : '40px',
        marginLeft: 2,
      }
    }
  };
});
